
export function isDiscount(repo: { langCode: string, }, currency: string): boolean {
  const domain = window.location.hostname;
  const startDate = Date.UTC(2026, 4, 11, 0, 0, 1);
  const endDate = Date.UTC(2026, 5, 19, 23, 59, 59);
  const now = Date.now()
  return repo.langCode === "no" && now > startDate && now < endDate && domain.endsWith('.no') && currency === 'NOK';
}
